/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_02a73942"]'><cube-slider :value="(30)" :custom-content="(true)" @change='(e)=>__invoke(e, [["handleChange"]])' @changing='(e)=>__invoke(e, [["handleChanging"]])'><div :class='["slider-thumb"]'><div :class='["box"]'></div></div></cube-slider></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_02a73942"}'>
.slider-thumb
  position relative
  width: 100%
  height: 100%
  background-image: url("https://gift-pypu-cdn.didistatic.com/static/driver_miniprogram/do1_E57CMf3cLCRJiq2VxPuT")
  background-size: contain
  background-repeat: no-repeat
  background-position: 0 6px
.box
  position absolute
  left 50%
  height 28px
  width 28px
  transform translateX(-50%)
  padding-left 100px
  padding-right 100px
  background-color pink
  opacity 0.3
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_02a73942"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_02a73942"}
  /** script content **/
  require("./slider-slot.mpx.js?isComponent&outputPath=components%2Fslider-slot02a73942%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./slider-slot.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fslider-slot02a73942%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_02a73942"],
    ctorType: "component",
    outputPath: "components/slider-slot02a73942/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-slider':getComponent(require("../../../packages/mpx-cube-ui/src/components/slider/index.mpx?isComponent&outputPath=components%2Findex999434b0%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>